import { Link } from "react-router-dom";

import { FaChevronLeft } from "react-icons/fa";

import styles from "./SectionHeader.module.css";

const SectionHeader = ({

    title,

    link,

    linkText = "مشاهده همه",

}) => {

    return (

        <div className={styles.wrapper}>

            <h2 className={styles.title}>

                {title}

            </h2>

            {

                link && (

                    <Link

                        to={link}

                        className={styles.link}

                    >

                        <span>

                            {linkText}

                        </span>

                        <FaChevronLeft />

                    </Link>

                )

            }

        </div>

    );

};

export default SectionHeader;